export interface UsefulInfoGlobalSnapshotEntry {
  taxiApps: string[];
  foodDeliveryApps: string[];
  lgbtqCriminalising: boolean;
  lgbtqDeathPenaltyPossible: boolean;
  transExpressionCriminalised: boolean;
}

export const USEFUL_INFO_GLOBAL_SNAPSHOT_META = {
  version: "2026-10-08.1",
  reviewedAt: "2026-10-08",
  reviewMode: "manual-approval-required",
  sources: {
    uberRides: "https://www.uber.com/it/it/r/cities/",
    boltRides: "https://bolt.eu/en/cities/",
    grabRides: "https://www.grab.com/sg/locations/",
    uberEats: "https://www.ubereats.com/location",
    wolt: "https://careers.wolt.com/en/locations",
    doorDash: "https://help.doordash.com/consumers/s/article/Country-and-Language-Availability-for-Consumer?language=en_US",
    foodpanda: "https://www.foodpanda.com/about-foodpanda/",
    deliveroo: "https://help.deliveroo.com/en/collections/1873159-contact-us",
    lgbtqCriminalisation: "https://www.humandignitytrust.org/lgbt-the-law/map-of-criminalisation/",
    diplomaticMissions: "https://www.wikidata.org/"
  }
} as const;

function codes(value: string): Set<string> {
  return new Set(value.trim().split(/\s+/).filter(Boolean));
}

const RIDE_PROVIDERS: Record<string, Set<string>> = {
  Uber: codes(`
    AD AE AR AT AU BD BE BH BO BR CA CH CL CO CR CZ DE DK DO EC EE EG ES FI FR GB GH GR GT HK HN HR HU IE IN IT JM JO JP KE KR LB LK LT LU MT MX NG NL NO NP NZ PA PE PL PT PY QA RO SA SE SI SK SV TR TW UA UG US UY ZA
  `),
  Bolt: codes(`
    AE AT AZ BE BG CH CY CZ DE DK EE ES FI FR GB GE GH GR HR HU IE IT KE KZ LT LV MA MD MT MX MY NG NL NO NZ PL PT PY RO SA SE SI SK TH TW TZ UA UG ZA ZW
  `),
  Grab: codes(`
    SG MY ID PH TH VN MM KH
  `)
};

const FOOD_PROVIDERS: Record<string, Set<string>> = {
  "Uber Eats": codes(`
    AR AU BE CA CH CL CR DE DK DO EC ES FI FR GB GT IE IT JP KE LK LU MX NL NO NZ PA PL PT SE SV TR TW US ZA
  `),
  Wolt: codes(`
    AL AT AZ BG CY CZ DE DK EE FI GB GE GR HR HU IL IS KZ LT LU LV MK MT NO PL RO RS SE SI SK XK
  `),
  DoorDash: codes(`
    AU CA NZ US
  `),
  foodpanda: codes(`
    BD HK KH LA MM MY PH PK SG TH TW
  `),
  Deliveroo: codes(`
    AE BE FR GB HK IE IT KW
  `)
};

const LGBTQ_CRIMINALISING = codes(`
  AE AF BD BF BI BN CM DZ EG ER ET GD GH GM GN GY ID IQ IR JM KE KI KM KW LB LK LR LY MA ML MM MR MV MW MY NE NG OM PG PK PS QA SA SB SD SL SN SO SS SY SZ TD TG TM TN TO TT TV TZ UG UZ VC WS YE ZM ZW
`);

const LGBTQ_DEATH_PENALTY_POSSIBLE = codes(`
  AE AF BN IR MR NG PK QA SA SO UG YE
`);

const TRANS_EXPRESSION_CRIMINALISED = codes(`
  AE BN GM ID LB LK MM MW MY NG OM QA SA SS
`);

export function getUsefulInfoGlobalSnapshot(countryCode: string): UsefulInfoGlobalSnapshotEntry {
  const code = String(countryCode || "").trim().toUpperCase();
  const taxiApps = Object.entries(RIDE_PROVIDERS)
    .filter(([, countries]) => countries.has(code))
    .map(([name]) => name);
  const foodDeliveryApps = Object.entries(FOOD_PROVIDERS)
    .filter(([, countries]) => countries.has(code))
    .map(([name]) => name);
  return {
    taxiApps,
    foodDeliveryApps,
    lgbtqCriminalising: LGBTQ_CRIMINALISING.has(code),
    lgbtqDeathPenaltyPossible: LGBTQ_DEATH_PENALTY_POSSIBLE.has(code),
    transExpressionCriminalised: TRANS_EXPRESSION_CRIMINALISED.has(code)
  };
}
